module.exports = __webpack_public_path__ + "img/Z85-X18-中_10.8bf629e3.jpg";